import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';
import { PaginationService } from 'src/app/core/services/pagination.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-supplier',
  standalone: false,
  templateUrl: './supplier.component.html',
  styleUrl: './supplier.component.scss'
})
export class SupplierComponent {
 breadCrumbItems!: Array<{}>;
  suppliersForm!: UntypedFormGroup;
  submitted = false;
  showForm = false;
  isEditMode = false;
  editId: any = null;

  suppliers: any[] = [];
  categories: any[] = [];
  units: any[] = [];
   totalItems: any;
  isLoading = false;

  // Pagination
  page = 1;
  pageSize = 10;

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService,
    private paginationService: PaginationService
  ) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Inventory' },
      { label: 'Supplier', active: true }
    ];
    this.initializeForm();
    this.loadSuppliers();
    this.loadCategories();
    this.loadUnits();
  }

  initializeForm(): void {
  this.suppliersForm = this.fb.group({
    name: ['', Validators.required],
    code: ['', Validators.required],
    contactPerson: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    address: ['', Validators.required],
    city: ['', Validators.required],
    state: ['', Validators.required],
    pincode: ['', Validators.required],
    gstNumber: ['', Validators.required],
    is_active: [true]
  });
}

  get f() { return this.suppliersForm.controls; }

  toggleForm(): void {
    this.showForm = !this.showForm;
    if (!this.showForm) this.resetForm();
  }

  resetForm(): void {
    this.submitted = false;
    this.isEditMode = false;
    this.editId = null;
    this.suppliersForm.reset({
      gst_rate: 0,
      minimum_stock: 0,
      current_stock: 0,
      is_active: true
    });
  }

  loadSuppliers(): void {
    this.isLoading = true;
    this.api.get(`/suppliers?page=${this.page}&limit=${this.pageSize}`).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.success) {
          this.suppliers = res.data || [];
          this.totalItems = Number(res.total) || 0;
          this.pageSize = Number(res.perPage) || this.pageSize;
          this.page = Number(res.currentPage) || this.page;
        }
      },
      error: () => (this.isLoading = false)
    });
  }

  loadCategories(): void {
    this.api.get('/categories').subscribe({
      next: (res: any) => {
        if (res.success) this.categories = res.data;
      }
    });
  }

  loadUnits(): void {
    this.api.get('/units').subscribe({
      next: (res: any) => {
        if (res.success) this.units = res.data;
      }
    });
  }

  saveSuppliers(): void {
      this.submitted = true;
      if (this.suppliersForm.invalid) return;

      const f = this.suppliersForm.value;
      const payload = {
        name: f.name,
        code: f.code,
        contact_person: f.contactPerson,
        email: f.email,
        mobile: f.mobile,
        address: f.address,
        city: f.city,
        state: f.state,
        pincode: f.pincode,
        gst_number: f.gstNumber,
        is_active: f.is_active
      };

      if (this.isEditMode && this.editId) {
        this.api.put(`/suppliers/${this.editId}`, payload).subscribe({
          next: (res: any) => {
            if (res.success) {
              Swal.fire('Success', 'Supplier updated successfully', 'success');
              this.loadSuppliers();
              this.toggleForm();
            }
          }
        });
      } else {
        this.api.post('/suppliers', payload).subscribe({
          next: (res: any) => {
            if (res.success) {
              Swal.fire('Success', 'Supplier created successfully', 'success');
              this.loadSuppliers();
              this.toggleForm();
            }
          }
        });
      }
    }


  editSuppliers(suppliers: any): void {
    this.showForm = true;
    this.isEditMode = true;
    this.editId = suppliers.id;
    this.suppliersForm.patchValue(suppliers);
  }

  deleteSuppliers(id: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this suppliers!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    }).then(result => {
      if (result.isConfirmed) {
        this.api.delete(`/suppliers/${id}`).subscribe({
          next: (res: any) => {
            if (res.success) {
              Swal.fire('Deleted!', 'Suppliers deleted successfully', 'success');
              this.loadSuppliers();
            }
          }
        });
      }
    });
  }

  changePage(page: number): void {
    this.page = page;
    this.loadSuppliers();
  }

  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}